import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-权限管理",
  "use": "icon-权限管理-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-权限管理\"><defs><style type=\"text/css\"></style></defs><path d=\"M645.1 531.9C753.7 458.3 782 310.6 708.4 202S487.2 65.2 378.6 138.8 241.7 360 315.3 468.6c16.9 24.9 38.4 46.4 63.3 63.3C214.8 579.6 96.7 712.5 96.7 869v59.2H334V869H156c0-160.9 153.9-292 345.7-296.4h20C577 573.8 631.5 586 682 608.7l-177.3 177-83.6-83.8-41.8 42 125.9 125.9 23.1-23.1L736 639.1c79.7 49.8 129.1 136.3 131.6 230.2H689.8v58.9h237.5V869c0-156.5-118.1-289.4-282.2-337.1z m-133.1-19c-98.2 0-177.8-79.6-177.8-177.8 0-98.2 79.6-177.8 177.8-177.8 98.2 0 177.8 79.6 177.8 177.8S610.2 512.9 512 512.9z\" p-id=\"2450\" fill=\"#ffffff\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/权限管理.svg
// module id = VUTz
// module chunks = 28